import React from 'react';
import { saveProfile } from '../services/profileService';

function AccountIndexPage({
  onClose,
  onNavigateToOrders,
  onNavigateToAddresses,
  onNavigateToPrivacy,
  onNavigateToTerms,
  onNavigateToHelp,
  onNavigateToShare,
  onLogout,
  userName,
  userPhone,
  userId,
}) {
  const [showLogoutConfirm, setShowLogoutConfirm] = React.useState(false);
  const [isEditingName, setIsEditingName] = React.useState(false);
  const [editNameValue, setEditNameValue] = React.useState('');
  const [nameStatus, setNameStatus] = React.useState('');
  const [isSavingName, setIsSavingName] = React.useState(false);

  const handleEditName = () => {
    setEditNameValue(userName || '');
    setNameStatus('');
    setIsEditingName(true);
  };

  const handleSaveName = async () => {
    if (!editNameValue.trim()) {
      setNameStatus('Name cannot be empty.');
      return;
    }
    try {
      setIsSavingName(true);
      setNameStatus('');
      await saveProfile(userId, { name: editNameValue.trim() });
      setNameStatus('Saved!');
      setTimeout(() => {
        setIsEditingName(false);
        setNameStatus('');
      }, 800);
    } catch (e) {
      setNameStatus('Failed to save. Try again.');
    } finally {
      setIsSavingName(false);
    }
  };
  
  const handleLogoutClick = () => {
    setShowLogoutConfirm(true);
  };
  
  const handleConfirmLogout = () => {
    setShowLogoutConfirm(false);
    onLogout();
  };
  
  const handleCancelLogout = () => {
    setShowLogoutConfirm(false);
  };
  const menuItems = [
    {
      icon: '📦',
      label: 'My Order',
      onClick: onNavigateToOrders,
      color: '#ff6b35'
    },
    {
      icon: '📍',
      label: 'Manage Address',
      onClick: onNavigateToAddresses,
      color: '#10b981'
    },
    {
      icon: '🔒',
      label: 'Privacy and Policy',
      onClick: onNavigateToPrivacy,
      color: '#6366f1'
    },
    {
      icon: '📜',
      label: 'Terms and Conditions',
      onClick: onNavigateToTerms,
      color: '#ec4899'
    },
    {
      icon: '❓',
      label: 'Help and Support',
      onClick: onNavigateToHelp,
      color: '#14b8a6'
    },
    {
      icon: '📤',
      label: 'Share',
      onClick: onNavigateToShare,
      color: '#06b6d4'
    },
    {
      icon: '🚪',
      label: 'Log Out',
      onClick: handleLogoutClick,
      color: '#64748b'
    }
  ];

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '100dvh', 
      background: '#f8f9fa', 
      overflow: 'hidden' 
    }}>

      {/* Scrollable Content */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        paddingBottom: '80px',
      }}>
        {/* Profile Card */}
        <div style={{
          background: 'white',
          margin: '16px',
          borderRadius: '20px',
          padding: '24px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          textAlign: 'center',
        }}>
          {/* Avatar */}
          <div style={{
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #ff6b35 0%, #ff8a5b 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px',
            border: '4px solid white',
            boxShadow: '0 4px 12px rgba(255,107,53,0.3)',
          }}>
            <span style={{ fontSize: '48px' }}>
              {userName ? userName.charAt(0).toUpperCase() : '👤'}
            </span>
          </div>

          {/* Name — editable */}
          {isEditingName ? (
            <div style={{ marginBottom: '12px' }}>
              <input
                type="text"
                value={editNameValue}
                onChange={(e) => setEditNameValue(e.target.value)}
                autoFocus
                style={{
                  fontSize: '18px', fontWeight: '700', color: '#111827',
                  border: '1.5px solid #ff6b35', borderRadius: '10px',
                  padding: '8px 12px', outline: 'none', textAlign: 'center',
                  width: '100%', boxSizing: 'border-box', background: '#fff7ed',
                }}
                onKeyDown={(e) => { if (e.key === 'Enter') handleSaveName(); if (e.key === 'Escape') setIsEditingName(false); }}
              />
              <div style={{ display: 'flex', gap: '8px', marginTop: '8px', justifyContent: 'center' }}>
                <button
                  onClick={handleSaveName}
                  disabled={isSavingName}
                  style={{
                    padding: '8px 20px', borderRadius: '8px', border: 'none',
                    background: 'linear-gradient(135deg, #ff6b35, #c2410c)',
                    color: 'white', fontSize: '13px', fontWeight: '700', cursor: 'pointer',
                  }}
                >
                  {isSavingName ? 'Saving…' : 'Save'}
                </button>
                <button
                  onClick={() => { setIsEditingName(false); setNameStatus(''); }}
                  style={{
                    padding: '8px 20px', borderRadius: '8px',
                    border: '1.5px solid #e5e7eb', background: 'white',
                    color: '#374151', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
                  }}
                >
                  Cancel
                </button>
              </div>
              {nameStatus && (
                <p style={{
                  margin: '8px 0 0', fontSize: '12px', textAlign: 'center',
                  color: nameStatus === 'Saved!' ? '#10b981' : '#ef4444',
                }}>{nameStatus}</p>
              )}
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '8px' }}>
              <h2 style={{ margin: 0, fontSize: '22px', fontWeight: '700', color: '#111827' }}>
                {userName || 'Guest User'}
              </h2>
              <button
                onClick={handleEditName}
                title="Edit name"
                style={{
                  background: '#f3f4f6', border: 'none', borderRadius: '6px',
                  padding: '4px 8px', cursor: 'pointer', fontSize: '13px',
                  color: '#6b7280', fontWeight: '600', lineHeight: 1,
                }}
              >
                ✏️
              </button>
            </div>
          )}

          {/* Phone number */}
          <p style={{ margin: 0, fontSize: '14px', color: '#6b7280', letterSpacing: '0.3px' }}>
            📱 {userPhone || '—'}
          </p>
        </div>

        {/* Menu Items */}
        <div style={{
          background: 'white',
          margin: '0 16px 16px',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}>
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={item.onClick}
              style={{
                width: '100%',
                background: 'none',
                border: 'none',
                borderBottom: index < menuItems.length - 1 ? '1px solid #f3f4f6' : 'none',
                padding: '16px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                cursor: 'pointer',
                transition: 'background 0.2s',
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
            >
              <div style={{
                fontSize: '24px',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '10px',
                background: `${item.color}15`,
              }}>
                {item.icon}
              </div>
              <div style={{
                flex: 1,
                textAlign: 'left',
                fontSize: '15px',
                fontWeight: '600',
                color: '#111827',
              }}>
                {item.label}
              </div>
              <span style={{ fontSize: '18px', color: '#9ca3af' }}>›</span>
            </button>
          ))}
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          padding: '20px',
          animation: 'fadeIn 0.2s ease-out',
        }}>
          <div style={{
            background: 'white',
            borderRadius: '20px',
            padding: '28px 24px',
            maxWidth: '340px',
            width: '100%',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
            animation: 'slideUpModal 0.3s ease-out',
          }}>
            <div style={{
              fontSize: '48px',
              textAlign: 'center',
              marginBottom: '16px',
            }}>
              👋
            </div>
            <h3 style={{
              margin: '0 0 12px 0',
              fontSize: '20px',
              fontWeight: '700',
              color: '#111827',
              textAlign: 'center',
            }}>
              Log Out?
            </h3>
            <p style={{
              margin: '0 0 24px 0',
              fontSize: '14px',
              color: '#6b7280',
              textAlign: 'center',
              lineHeight: '1.6',
            }}>
              Are you sure you want to log out of your account?
            </p>
            <div style={{
              display: 'flex',
              gap: '12px',
            }}>
              <button
                onClick={handleCancelLogout}
                style={{
                  flex: 1,
                  padding: '14px',
                  borderRadius: '12px',
                  border: '2px solid #e5e7eb',
                  background: 'white',
                  color: '#374151',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#f9fafb';
                  e.currentTarget.style.borderColor = '#d1d5db';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.borderColor = '#e5e7eb';
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmLogout}
                style={{
                  flex: 1,
                  padding: '14px',
                  borderRadius: '12px',
                  border: 'none',
                  background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                  color: 'white',
                  fontSize: '15px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 16px rgba(239, 68, 68, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.3)';
                }}
              >
                Log Out
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUpModal {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
}

export default AccountIndexPage;

// Made with Bob
